import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import Mask from "../../services/mask";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import Checkbox from "../../Components/Checkbox";
import DuploFator from "../../Components/DuploFator";

export default function TimeDeCraques() {
  const [eu, setEu] = useState({
    email: "",
    dataNascimento: "",
  });
  const [tipoModal, setTipoModal] = useState(0);
  const [emailAntigo, setEmailAntigo] = useState("");
  const [codigoEmail, setCodigoEmail] = useState("");
  const { load, setLoad } = useLoad();
  const [abrirDuploFator, setAbrirDuploFator] = useState(false);
  const [veioData, setVeioData] = useState(null);
  const [verificaAntes, setVerificaAntes] = useState(true);
  const [verificaFechamento, setVerificaFechamento] = useState(null);
  const [tokenAcesso, setTokenAcesso] = useState("");

  async function fnBtEuMeusDadosComCodigo() {
    setTipoModal(0);
    var objEnvio = {
      email: eu.email,
      dataNascimento: moment(eu.dataNascimento, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      ),
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPut(
        "eumeusdadoscomcodigo/" + codigoEmail,
        objEnvio
      );

      response.json().then((res) => {
        if (res.statusCode == 422) {
          toast.error(res.message);
        }
      });
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnBtEuMeusDados() {
    var objEnvio = {
      email: eu.email,
      dataNascimento: eu.dataNascimento
        ? moment(eu.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD")
        : null,
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPut("eumeusdados", objEnvio);
      if (response.statusCode != 200) {
        toast.error(response.message);
        if (verificaFechamento != true) {
          setAbrirDuploFator(false);
        }
      } else {
        if (verificaFechamento != true) {
          setAbrirDuploFator(true);
        }
      }
      if (verificaAntes != true) {
        fnCatalogo();
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnCatalogo() {
    const usuario = storage.get("USUARIO");
    const token = usuario?.loginResponse?.token || storage.get("TOKEN");

    if (typeof token !== "string" || token.trim() === "") {
      toast.error("Token de acesso ao catálogo não encontrado.");
      setVerificaAntes(true);
      setAbrirDuploFator(false);
      return;
    }

    var objEnvio = {
      token: token,
      CodigoDuploFator: tokenAcesso,
      mes: "",
      ano: "",
    };

    if (verificaAntes != true) {
      try {
        setLoad(true);
        let response = await ApiServices.apiPost(
          "vitrineorder/catalogo",
          objEnvio
        );
        if (response.statusCode == 200) {
          toast.success("Acesso ao catálogo liberado com sucesso");
          setAbrirDuploFator(false);
          setVerificaAntes(true);
          window.location.href = response.data.message;
        } else {
          setVerificaAntes(true);
          setAbrirDuploFator(false);
          toast.error(response.message);
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        setLoad(false);
      }
    }
  }

  async function fnEu() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("eu");
      setEmailAntigo(response.data.email);
      if (response.data.dataNascimento) {
        setVeioData(true);
        response.data.dataNascimento = moment(
          response.data.dataNascimento
        ).format("DD/MM/YYYY");
      } else {
        response.data.dataNascimento = "";
        setVeioData(false);
      }

      setEu(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnEu();
    // fnUf();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tokenAcesso != "") {
      fnBtEuMeusDados();
    }
  }, [tokenAcesso]);

  return (
    <>
      {abrirDuploFator && (
        <DuploFator
          setAbrirDuploFator={setAbrirDuploFator}
          setTokenAcesso={setTokenAcesso}
          setVerificaAntes={setVerificaAntes}
          setVerificaFechamento={setVerificaFechamento}
        />
      )}
      <div className="d-flex justify-content-center maisPremiosContainer">
        <div className="container maisPremiosContent">
          <div className="tituloPremios">
            <div className="tituloPrincipal">Mais Prêmios</div>
            <div className="tituloSecundario">Marketplace</div>
          </div>
          
          <div className="text-fiqueLigado">
            Fique ligado!
          </div>
          
          <div className="text-infoMaisPremios">
            Não deixe de validar seus dados para seguir com o acesso ao catálogo de prêmios. Caso a sua data de nascimento esteja em branco, preencha o campo abaixo.
          </div>

          <div className="campoDataNascimento">
            <div className="col-md-6 mb-3 campo-busca">
              <label htmlFor="dataNascimento" className="form-label">
                Data nascimento
              </label>
              <input
                id="dataNascimento"
                type="text"
                placeholder="XX/XX/XXXX"
                disabled={
                  eu.dataNascimento.length == 10 && veioData ? true : false
                }
                value={eu.dataNascimento}
                onChange={(e) => {
                  setEu((prevState) => ({
                    ...prevState,
                    dataNascimento: Mask.date(e.target.value),
                  }));
                }}
                className="form-control"
                style={{ textAlign: "center" }}
              />
            </div>
          </div>

          <div className="botaoConfirmar">
            <button
              className="btn btn-warning btnConfirmarDados"
              onClick={() => {
                fnBtEuMeusDados();
              }}
            >
              CONFIRMAR DADOS E ACESSAR CATÁLOGO
            </button>
          </div>
        </div>
        {/* MODAL */}
        {/* MODAL */}
        {/* MODAL */}
        {/* MODAL */}
        {/* MODAL */}
        <Modal
          keepMounted
          open={tipoModal != 0}
          onClose={() => setTipoModal(0)}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box className="configModal">
            <div className="d-flex justify-content-end pointer">
              <CloseIcon onClick={() => setTipoModal(0)} />
            </div>
            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
            >
              {tipoModal == 1 ? <>Alteração de E-mail</> : null}
            </Typography>
            <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
              {tipoModal == 1 ? (
                <span>
                  {" "}
                  Foi enviado um código para o e-mail: <b> {emailAntigo}</b>,
                  para confirmar a alteração forneça o código no campo abaixo.
                </span>
              ) : null}
            </Typography>
            {tipoModal == 1 ? (
              <div className="w-100 d-flex flex-column align-items-center">
                <div className="my-4 col-md-8 campo-busca">
                  <label htmlFor="codigoEmail" className="form-label">
                    Código
                  </label>
                  <input
                    id="codigoEmail"
                    type="text"
                    className="form-control"
                    value={codigoEmail}
                    onChange={(e) => setCodigoEmail(e.target.value)}
                  />
                </div>
                <button
                  className="btn btn-success"
                  disabled={!codigoEmail}
                  onClick={fnBtEuMeusDadosComCodigo}
                >
                  Confirmar Alteração
                </button>
              </div>
            ) : null}
          </Box>
        </Modal>
      </div>
    </>
  );
}
